import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';

import { ErrorResponse } from '@components/pages/Organization/types';
import { deactivateCorporateSubscription } from '@utils/backend-api/corporateSubscriptions';
import {
  ACTIVE_USERS_KEY,
  ARCHIVED_USERS_KEY,
  ORGANIZATION_ANALYTICS_KEY,
  ORGANIZATION_DETAILS_KEY,
} from '@utils/backend-api/organizations';

const useCorporateSubscriptionDeactivate = () => {
  const queryClient = useQueryClient();

  return useMutation((id: number) => deactivateCorporateSubscription(id), {
    onSuccess: ({ message }) => {
      toast.success(message);

      queryClient.invalidateQueries([ORGANIZATION_DETAILS_KEY]);
      queryClient.invalidateQueries([ORGANIZATION_ANALYTICS_KEY]);
      queryClient.invalidateQueries([ACTIVE_USERS_KEY]);
      queryClient.invalidateQueries([ARCHIVED_USERS_KEY]);
    },
    onError: (e: ErrorResponse) => {
      toast.error(e.message);
    },
  });
};

export default useCorporateSubscriptionDeactivate;
